import React from 'react';
import ReactDOM from 'react-dom';

const ModalPortal = ({ children }) => {
    // Получаем элемент, куда будем рендерить модальное окно
    const modalRoot = document.getElementById('modal-root');

    // Если элемент не найден (на случай ошибок), возвращаем null
    if (!modalRoot) return null;

    // Используем createPortal для рендеринга дочерних элементов (вашей формы)
    // в контейнер #modal-root
    return ReactDOM.createPortal(
        children,
        modalRoot
    );
};

export default ModalPortal;